import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const ArticlesOfAssociation = ({
  isOptional,
  isSubmitted,
  status,
}: TProps) => {
  return (
    <DocumentRequirement
      title={t`Articles of association`}
      documentType="articles of association"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>
        <Trans>Please upload your business license</Trans>
      </p>
    </DocumentRequirement>
  );
};
